export default __webpack_public_path__ + "static/paycheck-logo-80201666cdce3d2ab2e171614b2cfd5f.png";